import { apiClient } from '@/shared/api';

import type { AssetResponse, MediaOwnerType, MediaVisibility, UploadAssetParams } from '../model/types';

const BASE = '/api/v1/catalog/media';

export const uploadAsset = async (params: UploadAssetParams): Promise<AssetResponse> => {
  const form = new FormData();
  form.append('file', params.file);
  form.append('ownerType', params.ownerType);
  if (params.ownerId) form.append('ownerId', params.ownerId);
  if (params.visibility) form.append('visibility', params.visibility);
  const { data } = await apiClient.post<AssetResponse>(BASE, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const listAssets = async (params: {
  ownerType: MediaOwnerType;
  ownerId?: string;
  visibility?: MediaVisibility;
}): Promise<AssetResponse[]> => (await apiClient.get<AssetResponse[]>(BASE, { params })).data;
